// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Malaysia from '../_raw/flag/icon_flag_malaysia.png';

export default () => <img src={Malaysia} alt="Malaysia" />;
